module.exports = __webpack_public_path__ + "img/neudorf-main.69268409.webp";